import React from "react";
import RolePanel from "./RolePanel";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import strings from "../../config/localization";
import { useNavigate, useParams } from "react-router-dom";

export default function NewUserPage2() {
  const navigate = useNavigate();
  const { userId } = useParams();
  return (
    <div>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <RolePanel userId={userId!} showBackButton={false} />
          </Grid>
          <Grid item xs={1}>
            <Button variant="contained" onClick={() => navigate("/users")}>
              {strings.finish}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
